"use client";
import styles from "./Gallery.module.scss";
import { useState } from "react";
import Image from "next/image";
import Slider from "react-slick";
import Gallerymodal from "../Gallerymodal/Gallerymodal";

export default function Gallery() {
  const [clickedImage, setClickedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const settings = {
    infinite: true,
    arrows: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 4,
    slidesToScroll: 1,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const gallerImages = [
    {
      bgImage: "/images/res-gallery/res-gal1.jpg",
      title: "Chicken Munchaw Soup",
    },
    {
      bgImage: "/images/res-gallery/res-gal2.jpg",
      title: "Chicken Munchaw Soup",
    },
    {
      bgImage: "/images/res-gallery/res-gal3.jpg",
      title: "Chicken Munchaw Soup",
    },
    {
      bgImage: "/images/res-gallery/res-gal4.jpg",
      title: "Chicken Munchaw Soup",
    },
    {
      bgImage: "/images/res-gallery/res-gal5.jpg",
      title: "Chicken Munchaw Soup",
    },
    {
      bgImage: "/images/res-gallery/res-gal6.jpg",
      title: "Chicken Munchaw Soup",
    },
    {
      bgImage: "/images/res-gallery/res-gal7.jpg",
      title: "Chicken Munchaw Soup",
    },
    {
      bgImage: "/images/res-gallery/res-gal8.jpg",
      title: "Chicken Munchaw Soup",
    },
  ];

  const handleClick = (item, index) => {
    setCurrentIndex(index);
    setClickedImage(item.bgImage);
  };

  const handleRotationRight = () => {
    const totalLength = gallerImages.length;
    if (currentIndex + 1 >= totalLength) {
      setCurrentIndex(0);
      const newUrl = gallerImages[0].bgImage;
      setClickedImage(newUrl);
      return;
    }
    const newIndex = currentIndex + 1;
    const newUrl = gallerImages.filter((item) => {
      return gallerImages.indexOf(item) === newIndex;
    });
    const newItem = newUrl[0].bgImage;
    setClickedImage(newItem);
    setCurrentIndex(newIndex);
  };

  return (
    <>
      <section className={`${styles.gallery_sec} mt-4`}>
        <Slider {...settings} className="dining_slider">
          {gallerImages.map((item, index) => (
            <div
              className={styles.gallery_child}
              key={index}
              onClick={() => handleClick(item, index)}
            >
              <Image
                src={item.bgImage}
                alt={item.title}
                onClick={() => handleClick(item, index)}
                fill
                sizes="(max-width: 767px) 100vw, 50vw"
              ></Image>
              <div className={styles.gallery_inner}>
                {/* <h3 className={styles.gallery_text}>{item.title}</h3> */}
              </div>
            </div>
          ))}
        </Slider>
        {clickedImage && (
          <Gallerymodal
            clickedImage={clickedImage}
            handleRotationRight={handleRotationRight}
            setClickedImage={setClickedImage}
          />
        )}
      </section>
    </>
  );
}
